<template>
  <div class="list_message">
    <div class="top">
      <div class="title">
        <span class="name">{{record.projectName}}</span>
        <div class="state">
          <!-- <span v-if="record.projectProgress == 1">储备</span>
          <span v-if="record.projectProgress == 2">意向</span>
          <span v-if="record.projectProgress == 3">签约</span>
          <span v-if="record.projectProgress == 4">落地</span>
          <span v-if="record.projectProgress == 5">完成</span> -->
          <span>{{record.projectProgressName}}</span>
        </div>
      </div>
      <span class="process pending" v-if="record.status == 1">审核中</span>
      <span class="process pass" v-if="record.status == 3">审核通过</span>
      <span class="process reject" v-if="record.status == 2">审核驳回</span>
    </div>
    <div class="body">
      <p class="content">
        <span class="title">{{record.projectTypeName}}</span>
        <span class="obj">投资金额：{{record.investmentMoney}} 亿</span>
      </p>
      <p class="content">
        <span class="title">{{record.locationName}}</span>
        <span class="obj">{{record.createTime}}</span>
      </p>
    </div>
    <div class="foot">
      <span @click="$router.push({path: '/investment/projectDetails',query:{id:record.id}})">查看详情</span>
      <img @click="$router.push({path: '/investment/projectDetails',query:{id:record.id}})" src="../../../assets/investment/jinru.png" alt="">
    </div>
  </div>
</template>

<script>

export default {
  name: "listMessage",
  components: {},
  props: {
    record: {

    }
  },
  data() {
    return {};
  },
  computed: {},
  watch: {},
  methods: {},
  created() {},
  mounted() {},
};
</script>

<style lang="less" scoped>
.list_message {
    background: #FFFFFF;
    padding: 12px 20px;
    border-radius: 3px;
    margin-top: 12px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, .04);
    word-break:break-all;

    .top{
      display: flex;
      justify-content: space-between;
      .title{
        display: flex;
        align-items: flex-start;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .name{
        font-size: 16px;
        color: #333333;
        line-height: 22px;
        font-weight: bold;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .state{
        white-space: nowrap;
        margin-left: 10px;
        font-size: 12px;
        line-height: 14px;
        background: rgba(34, 131, 230, 0.1);
        color: #2283E6;
        padding: 2px 4px;
        border-radius: 1px;
        span{
          display: inline-block;
          margin-top: 2px;
          transform: scale(0.8333);
        }
      }
      .process{
        white-space: nowrap;
        margin-left: 20px;
        font-size: 12px;
        line-height: 22px;
      }
      .pending{
        color: #FF8C19;
      }
      .reject{
        color: #FF4D4D;
      }
      .pass{
        color: #36B374;
      }
    }
    .body{
      padding-top: 12px;
      border-bottom: 0.5px solid #EEEEEE;

      .content{
        margin-bottom: 12px;
        line-height: 17px;
        color: #333333;
        .title{
          min-width: 57px;
          border-right: 1px solid #ccc;
          padding-right: 10px;
          display: inline-block;
        }
        .obj{
          padding-left: 10px;
        }
      }
    }
    .foot{
      padding-top: 12px;
      span{
        display: inline-block;
        color: #36B374;
        line-height: 17px;
        font-size: 12px;
      }
      img{
        display: inline-block;
        width: 4px;
        height: 8px;
        margin-left: 5px;
      }
    }
}
</style>
